import React from 'react'

import { ROUTE_NAME, API_URL } from '../constants'

import ItemDelete from '../../components/Delete'

const UserDelete = () => (
  <ItemDelete
    routeName={ROUTE_NAME}
    apiUrl={API_URL}
    label={(item) => `User (#${item.id}): ${item.username}`}
  />
)

export default UserDelete
